import React from 'react';
import MessageBubble from './MessageBubble';
import './MessageList.css';

function MessageList({ messages, currentUserId, onReply, onDelete, onReport }) {
  const groupMessagesByDate = (messages) => {
    const groups = {};
    messages.forEach(message => {
      const date = new Date(message.createdAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(message);
    });
    return groups;
  };

  const messageGroups = groupMessagesByDate(messages);

  if (messages.length === 0) {
    return (
      <div className="message-list-empty">
        <p className="text-muted">No messages yet. Start the conversation!</p>
      </div>
    );
  }

  return (
    <div className="message-list">
      {Object.entries(messageGroups).map(([date, dateMessages]) => (
        <div key={date} className="message-date-group">
          <div className="message-date-divider">
            <span>{date}</span>
          </div>
          {dateMessages.map((message, index) => {
            const isOwn = message.senderId === currentUserId;
            const showAvatar =
              index === dateMessages.length - 1 ||
              dateMessages[index + 1]?.senderId !== message.senderId;

            return (
              <MessageBubble
                key={message.messageId}
                message={message}
                isOwn={isOwn}
                showAvatar={showAvatar}
                onReply={onReply}
                onDelete={onDelete}
                onReport={onReport}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default MessageList;
